/**
 * The plugins this one codebase publishes — see `variants.json` and
 * `@figma-importers/variants`. The first row is the plugin that has always
 * shipped from here; the others are listings named for what people search for,
 * each with a placeholder id until it is created in Figma.
 */

import table from '../variants.json';
import { defineVariants, type Variant, type VariantTable } from '@figma-importers/variants';

export type { Variant };

/** Which variant a sandbox bundle was built for, injected by esbuild's `define`. Only this module reads it. */
declare const __VARIANT_KEY__: string;

const defined = defineVariants(table as VariantTable, typeof __VARIANT_KEY__ === 'string' ? __VARIANT_KEY__ : undefined);

export const VARIANTS: Variant[] = defined.VARIANTS;
export const DEFAULT_VARIANT: Variant = defined.DEFAULT_VARIANT;
export const ACTIVE_VARIANT: Variant = defined.ACTIVE_VARIANT;
export const variantById = defined.variantById;
export const variantByKey = defined.variantByKey;
